export const AUTH_STEPS = {
    LOGIN: "login",
    OTP: "otp",
    PROFILE_RECOVERY: "profileRecovery",
    SUCCESS: "success",
    LOGGED_IN: "loggedIn",
} as const;

export type AuthStep =
    (typeof AUTH_STEPS)[keyof typeof AUTH_STEPS];